module.exports = __webpack_public_path__ + "img/vrgroup.651de803.jpg";